<template>
  <div>
    <el-card class="box-card">
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="4">
            <el-select style="width: 100%;" :size="componentSize" v-model="searchForm.tableSchema"
                       placeholder="请选择数据库" clearable>
              <el-option v-for="item in tableSchemas" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-col>
          <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="4">
            <el-input style="width: 100%;" :size="componentSize" v-model="searchForm.tableName" placeholder="请输入表名"
                      auto-complete="off" clearable @keyup.enter.native="pageList"></el-input>
          </el-col>
          <el-col :xs="24" :sm="24" :md="16" :lg="12" :xl="8">
            <el-form-item>
              <el-button :size="componentSize" type="primary" @click="pageList" icon="el-icon-search">搜索</el-button>
              <el-button :size="componentSize" type="primary" @click="generatorPropertyFormVisible = true"
                         icon="el-icon-setting">文件配置
              </el-button>
              <el-button :size="componentSize" type="primary" @click="generateFile" icon="el-icon-printer">生成文件
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <el-table :size="componentSize" ref="multipleTable" :data="page.records" tooltip-effect="dark"
                style="width: 100%;"
                border @selection-change="selectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="tableSchema" label="数据库"></el-table-column>
        <el-table-column prop="tableName" label="表名" min-width="200"></el-table-column>
        <el-table-column prop="engine" label="表引擎"></el-table-column>
        <el-table-column prop="tableComment" label="表介绍"></el-table-column>
        <el-table-column prop="createTime" label="日期" min-width="100"></el-table-column>
        <el-table-column prop="" label="操作" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <div class="operation-group">
              <span @click="generatorRuleFormVisible = true, generatorRuleForm.tableSchema = scope.row.tableSchema,
              generatorRuleForm.tableName = scope.row.tableName">规则配置</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                     style="margin-top: 20px;text-align: right;"
                     :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber"
                     @size-change="sizeChange" @current-change="currentChange">
      </el-pagination>
    </el-card>

    <el-dialog :title="searchForm.tableSchema + '生成文件配置'" width="80%" :visible.sync="generatorPropertyFormVisible" left>
      <el-form :model="generatorPropertyForm" :label-width="generatorFormLabelWidth" ref="generatorPropertyForm">
        <el-form-item v-show="false" label="id" prop="id">
          <el-input v-model="generatorPropertyForm.id" placeholder="" auto-complete="off"></el-input>
        </el-form-item>
        <el-row :span="24">
          <span>后台代码设置</span>
          <el-divider></el-divider>
        </el-row>
        <el-row :span="24" :gutter="20">
          <el-col :span="8">
            <el-form-item label="作者" prop="author">
              <el-input v-model="generatorPropertyForm.author" placeholder="请输入作者" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="接口地址" prop="apiUrl">
              <el-input v-model="generatorPropertyForm.apiUrl" placeholder="请输入接口地址(例如：http://localhost/api)"
                        auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24" :gutter="20">
          <el-col :span="8">
            <el-form-item label="bean包名" prop="beanPackage">
              <el-input v-model="generatorPropertyForm.beanPackage" placeholder="请输入bean包名(例如：com.example.demo.bean)"
                        auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="bean路径" prop="beanPath">
              <el-input v-model="generatorPropertyForm.beanPath"
                        placeholder="请输入bean路径(例如：c:\User\admin\project\demo\com\example\bean)"
                        auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24" :gutter="20">
          <el-col :span="8">
            <el-form-item label="entity包名" prop="entityPackage">
              <el-input v-model="generatorPropertyForm.entityPackage"
                        placeholder="请输入entity包名(例如：com.example.demo.entity)" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="entity路径" prop="entityPath">
              <el-input v-model="generatorPropertyForm.entityPath"
                        placeholder="请输入entity路径(例如：c:\User\admin\project\demo\com\example\entity)"
                        auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24" :gutter="20">
          <el-col :span="8">
            <el-form-item label="enum包名" prop="enumPackage">
              <el-input v-model="generatorPropertyForm.enumPackage" placeholder="请输入enum包名(例如：com.example.demo.enum)"
                        auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="enum路径" prop="enumPath">
              <el-input v-model="generatorPropertyForm.enumPath"
                        placeholder="请输入enum路径(例如：c:\User\admin\project\demo\com\example\enum)"
                        auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24" :gutter="20">
          <el-col :span="8">
            <el-form-item label="controller包名" prop="controllerPackage">
              <el-input v-model="generatorPropertyForm.controllerPackage"
                        placeholder="请输入controller包名(例如：com.example.demo.controller)" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="controller路径" prop="controllerPath">
              <el-input v-model="generatorPropertyForm.controllerPath"
                        placeholder="请输入controller路径(例如：c:\User\admin\project\demo\com\example\controller)"
                        auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24" :gutter="20">
          <el-col :span="8">
            <el-form-item label="service包名" prop="servicePackage">
              <el-input v-model="generatorPropertyForm.servicePackage"
                        placeholder="请输入service包名(例如：com.example.demo.service)" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="service路径" prop="servicePath">
              <el-input v-model="generatorPropertyForm.servicePath"
                        placeholder="请输入service路径(例如：c:\User\admin\project\demo\com\example\service)"
                        auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24" :gutter="20">
          <el-col :span="8">
            <el-form-item label="serviceImpl包名" prop="serviceImplPackage">
              <el-input v-model="generatorPropertyForm.serviceImplPackage"
                        placeholder="请输入serviceImpl包名(例如：com.example.demo.service.serviceImpl)"
                        auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="serviceImpl路径" prop="serviceImplPath">
              <el-input v-model="generatorPropertyForm.serviceImplPath"
                        placeholder="请输入serviceImpl路径(例如：c:\User\admin\project\demo\com\example\service\impl)"
                        auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24" :gutter="20">
          <el-col :span="8">
            <el-form-item label="mapper包名" prop="mapperPackage">
              <el-input v-model="generatorPropertyForm.mapperPackage"
                        placeholder="请输入mapper包名(例如：com.example.demo.mapper)" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="mapper路径" prop="mapperPath">
              <el-input v-model="generatorPropertyForm.mapperPath"
                        placeholder="请输入mapper路径(例如：c:\User\admin\project\demo\com\example\mapper)"
                        auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24" :gutter="20">
          <el-col :span="16" :offset="8">
            <el-form-item label="mapper映射xml文件路径" prop="mapperXmlPath">
              <el-input v-model="generatorPropertyForm.mapperXmlPath" placeholder="请输入mapper映射xml路径(例如：resource\mapper)"
                        auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <span>前端代码设置</span>
          <el-divider></el-divider>
        </el-row>
        <el-row :span="24" :gutter="20">
          <el-col :span="12">
            <el-form-item label="vue接口文件" prop="vueApiPath">
              <el-input v-model="generatorPropertyForm.vueApiPath"
                        placeholder="请输入vue接口文件(例如：c:\User\admin\vue\src\api)" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="vue页面文件" prop="vuePagePath">
              <el-input v-model="generatorPropertyForm.vuePagePath"
                        placeholder="请输入vue页面文件(例如：c:\User\admin\vue\src\components)" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="vue路由文件" prop="vueRouterPath">
              <el-input v-model="generatorPropertyForm.vueRouterPath"
                        placeholder="请输入vue路由文件(例如：c:\User\admin\vue\src\router)" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="componentSize" @click="generatorPropertyFormVisible = false">取 消</el-button>
        <el-button :size="componentSize" type="primary" @click="updateGeneratorProperty">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="生成规则" :visible.sync="generatorRuleFormVisible" left>
      <el-form :model="generatorRuleForm" :label-width="generatorRuleFormLabelWidth" ref="generatorRuleForm">
        <el-row :span="24">
          <span style="font-weight: bold;font-size: 2rem;">后台代码设置</span>
          <el-divider></el-divider>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开启后台校验" prop="backEndValidate">
              <el-switch v-model="generatorRuleForm.backEndValidate" active-color="#409EFF"
                         inactive-color="#D2D2D2"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否生成entity" prop="entityNeed">
              <el-switch v-model="generatorRuleForm.entityNeed" active-color="#409EFF"
                         inactive-color="#D2D2D2"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否生成enum" prop="enumNeed">
              <el-switch v-model="generatorRuleForm.enumNeed" active-color="#409EFF"
                         inactive-color="#D2D2D2"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否生成controller" prop="controllerNeed">
              <el-switch v-model="generatorRuleForm.controllerNeed" active-color="#409EFF"
                         inactive-color="#D2D2D2"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否生成service" prop="serviceNeed">
              <el-switch v-model="generatorRuleForm.serviceNeed" active-color="#409EFF"
                         inactive-color="#D2D2D2"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否生成serviceImpl" prop="serviceImplNeed">
              <el-switch v-model="generatorRuleForm.serviceImplNeed" active-color="#409EFF"
                         inactive-color="#D2D2D2"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否生成mapper" prop="mapperNeed">
              <el-switch v-model="generatorRuleForm.mapperNeed" active-color="#409EFF"
                         inactive-color="#D2D2D2"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否生成mapper.xml" prop="mapperXmlNeed">
              <el-switch v-model="generatorRuleForm.mapperXmlNeed" active-color="#409EFF"
                         inactive-color="#D2D2D2"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否开启伪删除" prop="pseudoDeleteNeed">
              <el-switch v-model="generatorRuleForm.pseudoDeleteNeed" active-color="#409EFF"
                         inactive-color="#D2D2D2"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="伪删除列名">
              <el-select v-model="generatorRuleForm.pseudoDeleteColumn" placeholder="请选择伪删除列名">
                <el-option v-for="item in tableColumns" :key="item.columnName" :label="item.columnName"
                           :value="item.columnName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否开启启用/禁用" prop="activeNeed">
              <el-switch v-model="generatorRuleForm.activeNeed" active-color="#409EFF"
                         inactive-color="#D2D2D2"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="启用/禁用列名">
              <el-select v-model="generatorRuleForm.activeColumn" placeholder="请选择启用/禁用列名">
                <el-option v-for="item in tableColumns" :key="item.columnName" :label="item.columnName"
                           :value="item.columnName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="创建时间列名">
              <el-select v-model="generatorRuleForm.createTimeColumn" placeholder="请选择创建时间列名">
                <el-option v-for="item in tableColumns" :key="item.columnName" :label="item.columnName"
                           :value="item.columnName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="修改时间列名">
              <el-select v-model="generatorRuleForm.updateTimeColumn" placeholder="请选择修改时间列名">
                <el-option v-for="item in tableColumns" :key="item.columnName" :label="item.columnName"
                           :value="item.columnName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="操作人id列名">
              <el-select v-model="generatorRuleForm.operatorIdColumn" placeholder="请选择操作人id列名">
                <el-option v-for="item in tableColumns" :key="item.columnName" :label="item.columnName"
                           :value="item.columnName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <span style="font-weight: bold;font-size: 2rem;">前台代码设置</span>
          <el-divider></el-divider>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开启前台校验" prop="frontEndValidate">
              <el-switch v-model="generatorRuleForm.frontEndValidate" active-color="#409EFF"
                         inactive-color="#D2D2D2"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否生成接口文件" prop="vueApiNeed">
              <el-switch v-model="generatorRuleForm.vueApiNeed" active-color="#409EFF"
                         inactive-color="#D2D2D2"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否生成页面" prop="vuePageNeed">
              <el-switch v-model="generatorRuleForm.vuePageNeed" active-color="#409EFF"
                         inactive-color="#D2D2D2"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否生成路由" prop="vueRouterNeed">
              <el-switch v-model="generatorRuleForm.vueRouterNeed" active-color="#409EFF"
                         inactive-color="#D2D2D2"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否显示搜索域label" prop="showSearchFormLabel">
              <el-switch v-model="generatorRuleForm.showSearchFormLabel" active-color="#409EFF"
                         inactive-color="#D2D2D2"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">树</el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item label="页面是否需要树" prop="vueTreeNeed">
              <el-switch v-model="generatorRuleForm.vueTreeNeed" active-color="#409EFF"
                         inactive-color="#D2D2D2"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <transition name="fade">
          <el-row v-show="generatorRuleForm.vueTreeNeed">
            <el-col :span="12">
              <el-form-item label="是否显示树CRUD" prop="treeCrudNeed">
                <el-switch v-model="generatorRuleForm.treeCrudNeed" active-color="#409EFF"
                           inactive-color="#D2D2D2"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="树关联表名" prop="treeAssociatedTable">
                <el-select v-model="generatorRuleForm.treeAssociatedTable" placeholder="请选择表" clearable>
                  <el-option v-for="item in tables" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </transition>
        <el-divider content-position="left">label</el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否显示按钮label" prop="showButtonLabel">
              <el-switch v-model="generatorRuleForm.showButtonLabel" active-color="#409EFF"
                         inactive-color="#D2D2D2"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否显示列表按钮label" prop="showPageListButtonLabel">
              <el-switch v-model="generatorRuleForm.showPageListButtonLabel" active-color="#409EFF"
                         inactive-color="#D2D2D2"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-collapse v-model="activeName" accordion>
          <el-collapse-item name="1">
            <template slot="title">
              搜索表单域（<i class="header-icon el-icon-info"></i><span>表单域的顺序根据选择顺序进行排序，下面表单域和列表相同</span>）
            </template>
            <el-checkbox-group v-model="generatorRuleForm.searchFormFields">
              <div v-for="(column, index) in tableColumns" style="display: block;margin: 5px;" :key="index">
                <el-checkbox :label="column.columnName" :key="column.columnName" :disabled="column.disabled"
                             style="width: 200px;">
                  {{column.columnName}}
                </el-checkbox>
                <el-select v-model="column.elementType" placeholder="请选择元素类型" @change="showRelationTable(column)"
                           clearable>
                  <el-option v-for="type in elementTypes" :key="type" :label="type" :value="type"></el-option>
                </el-select>
                <el-select v-show="column.relationTableVisible" v-model="column.relationTable" placeholder="请选择关联业务表"
                           clearable>
                  <el-option v-for="item in tables" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </div>
            </el-checkbox-group>
            <el-button :size="componentSize" type="primary" @click="combine">合并</el-button>
            <el-button :size="componentSize" @click="clear">清空</el-button>
            <el-card style="margin-top: 10px;" v-show="tags.length > 0">
              <el-row :gutter="20">
                <el-col v-for="(tag, index) in tags" style="margin-top: 5px;" :key="index">
                  <el-tag :key="tag.name" @close="close(tag)" closable>{{tag.name}}</el-tag>
                </el-col>
              </el-row>
            </el-card>
          </el-collapse-item>
          <el-collapse-item title="新增表单域" name="2">
            <el-checkbox-group v-model="generatorRuleForm.addFormFields">
              <div v-for="(column, index) in tableColumns" :key="index" style="display: block;margin: 5px;">
                <el-checkbox :label="column.columnName" :key="column.columnName" style="width: 200px;">
                  {{column.columnName}}
                </el-checkbox>
                <el-select v-model="column.elementType" placeholder="请选择元素类型" @change="showRelationTable(column)"
                           clearable>
                  <el-option v-for="type in elementTypes" :key="type" :label="type" :value="type"></el-option>
                </el-select>
                <el-select v-show="column.relationTableVisible" v-model="column.relationTable" placeholder="请选择关联业务表"
                           clearable>
                  <el-option v-for="item in tables" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </div>
            </el-checkbox-group>
          </el-collapse-item>
          <el-collapse-item title="编辑表单域" name="3">
            <el-checkbox-group v-model="generatorRuleForm.editFormFields">
              <div v-for="(column, index) in tableColumns" :key="index" style="display: block;margin: 5px;">
                <el-checkbox :label="column.columnName" :key="column.columnName" style="width: 200px;">
                  {{column.columnName}}
                </el-checkbox>
                <el-select v-model="column.elementType" placeholder="请选择元素类型" @change="showRelationTable(column)"
                           clearable>
                  <el-option v-for="type in elementTypes" :key="type" :label="type" :value="type"></el-option>
                </el-select>
                <el-select v-show="column.relationTableVisible" v-model="column.relationTable" placeholder="请选择关联业务表"
                           clearable>
                  <el-option v-for="item in tables" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </div>
            </el-checkbox-group>
          </el-collapse-item>
          <el-collapse-item title="详情表单域" name="4">
            <el-checkbox-group v-model="generatorRuleForm.detailFormFields">
              <div v-for="(column, index) in tableColumns" :key="index" style="display: block;margin: 5px;">
                <el-checkbox :label="column.columnName" :key="column.columnName" style="width: 200px;">
                  {{column.columnName}}
                </el-checkbox>
                <el-select v-model="column.elementType" placeholder="请选择元素类型" @change="showRelationTable(column)"
                           clearable>
                  <el-option v-for="type in elementTypes" :key="type" :label="type" :value="type"></el-option>
                </el-select>
                <el-select v-show="column.relationTableVisible" v-model="column.relationTable" placeholder="请选择关联业务表"
                           clearable>
                  <el-option v-for="item in tables" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </div>
            </el-checkbox-group>
          </el-collapse-item>
          <el-collapse-item title="列表展示列" name="5">
            <el-checkbox-group v-model="generatorRuleForm.pageListFields">
              <div v-for="(column, index) in tableColumns" :key="index" style="display: block;margin: 5px;">
                <el-checkbox :label="column.columnName" :key="column.columnName" style="width: 200px;">
                  {{column.columnName}}
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="componentSize" @click="generatorRuleFormVisible = false">取 消</el-button>
        <el-button :size="componentSize" type="primary" @click="addGeneratorRule">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        activeName: '1',
        elementTypes: ['number', 'input', 'textarea', 'select', 'multipleSelect', 'datePicker', 'dateRangePicker', 'datetimePicker', 'datetimeRangePicker', 'switch', 'checkbox', 'radio'],
        componentArray: ['select', 'multipleSelect', 'checkbox', 'radio'],
        page: {
          records: [],
          total: 0,
          pageSize: 10,
          pageNumber: 1,
          sortName: 'create_time',
          sortOrder: 'desc'
        },
        searchForm: {
          tableSchema: '',
          tableName: '',
        },
        checked: [],
        tags: [],
        tableSchemas: [],
        tables: [],
        formLabelWidth: '90px',
        generatorFormLabelWidth: '160px',
        generatorRuleFormLabelWidth: '140px',
        multipleSelection: [],
        generatorPropertyForm: {},
        generatorPropertyFormRules: [],
        generatorPropertyFormVisible: false,
        generatorForm: {},
        generatorRuleFormVisible: false,
        generatorRuleForm: {
          tableSchema: '',
          tableName: '',
          showSearchFormLabel: false,
          searchFormFields: [],
          searchFormCombineFields: [],
          addFormFields: [],
          editFormFields: [],
          detailFormFields: [],
          pageListFields: [],
          frontEndValidate: true,
          backEndValidate: true,
          entityNeed: true,
          enumNeed: true,
          controllerNeed: true,
          serviceNeed: true,
          serviceImplNeed: true,
          mapperNeed: true,
          mapperXmlNeed: true,
          pseudoDeleteNeed: true,
          pseudoDeleteColumn: '',
          activeNeed: true,
          activeColumn: '',
          vueApiNeed: true,
          vuePageNeed: true,
          vueRouterNeed: true,
          vueTreeNeed: true,
          treeCrudNeed: false,
          treeAssociatedTable: '',
          showButtonLabel: true,
          showPageListButtonLabel: false,
          createTimeColumn: '',
          updateTimeColumn: '',
          operatorIdColumn: ''
        },
        tableColumns: [],
        permissions: [],
        componentSize: '',
      };
    },
    methods: {
      setComponentSize() {
        if (document.body.clientWidth <= 992) {
          this.componentSize = 'mini'
          return
        }
        if (document.body.clientWidth <= 1200) {
          this.componentSize = 'small'
          return
        }
        if (document.body.clientWidth <= 1920) {
          this.componentSize = 'medium'
          return
        }
      },
      pageList() {
        this.api.generator.pageList({
          tableSchema: this.searchForm.tableSchema,
          tableName: this.searchForm.tableName,
          pageSize: this.page.pageSize,
          pageNumber: this.page.pageNumber,
          sortName: this.page.sortName,
          sortOrder: this.page.sortOrder
        }).then(result => {
          if (result.success) {
            this.page.records = result.data.records;
            this.page.total = result.data.total;
          } else {
            this.$message.error(result.message)
          }
        }).catch(error => {
          console.log(error)
        })
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize
        this.pageList()
      },
      currentChange(pageNumber) {
        this.page.pageNumber = pageNumber
        this.pageList()
      },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row)
          });
        } else {
          this.$refs.multipleTable.clearSelection()
        }
      },
      getTableSchemas() {
        this.api.generator.getTableSchemas().then(result => {
          this.tableSchemas = result.data
        }).catch(error => {
          console.log(error)
        })
      },
      getTables() {
        this.api.generator.getTables({
          tableSchema: this.generatorRuleForm.tableSchema,
        }).then(result => {
          if (result.success) {
            this.tables = result.data;
          } else {
            this.$message.error(result.message)
          }
        }).catch(error => {
          console.log(error)
        })
      },
      getPermissionList() {
        let user = JSON.parse(localStorage.user)
        // console.log('user', user)
        // user.resources.forEach(e => {
        //   e.resources.forEach(a => {
        //     a.resources.forEach(x => this.permissions.push(x.url))
        //   })
        // })
      },
      updateGeneratorProperty() {
        this.generatorPropertyForm.tableSchema = this.searchForm.tableSchema;
        this.api.generatorProperty.updateGeneratorProperty(this.generatorPropertyForm).then(result => {
          this.generatorPropertyFormVisible = false
          this.$message.success(result.message)
        }).catch(error => {
          console.log(error)
        })
      },
      generateFile() {
        if (this.multipleSelection.length === 0) {
          this.$message.error('请选择要生成的表')
          return
        }
        this.api.generator.generateFile({
          ip: document.domain,
          tableSchema: this.searchForm.tableSchema,
          tables: this.multipleSelection
        }).then(result => {
          if (result.success) {
            this.$message.success(result.message)
          } else {
            this.$message.error(result.message)
          }
        }).catch(error => {
          console.log(error)
        })
      },
      selectionChange(val) {
        this.multipleSelection = []
        val.forEach(e => {
          this.multipleSelection.push(e.tableName);
        })
      },
      getColumns() {
        this.api.generator.getColumns({
          tableSchema: this.generatorRuleForm.tableSchema,
          tableName: this.generatorRuleForm.tableName
        }).then(result => {
          if (result.success) {
            this.tableColumns = result.data;
            this.tableColumns.forEach(column => {
              if (column.elementType !== null) {
                return
              }
              if (column.dataType === 'float' || column.dataType === 'double' || column.dataType === 'int' || column.dataType === 'bigint' || column.dataType === 'decimal') {
                column.elementType = 'number'
              }
              if (column.dataType === 'char' || column.dataType === 'varchar' || column.dataType === 'text') {
                if (column.characterMaximumLength < 256) {
                  column.elementType = 'input'
                } else {
                  column.elementType = 'textarea'
                }
              }
              if (column.dataType === 'date') {
                column.elementType = 'datePicker'
              }
              if (column.dataType === 'datetime') {
                column.elementType = 'datetimePicker'
              }
            })
            this.getGeneratorRule();
          } else {
            this.$message.error(result.message)
          }
        }).catch(error => {
          console.log(error)
        })
      },
      getGeneratorProperty() {
        this.api.generatorProperty.getGeneratorProperty({
          tableSchema: this.searchForm.tableSchema
        }).then(result => {
          if (result.success) {
            this.generatorPropertyForm = result.data
          } else {
            this.$message.error(result.message)
          }
        }).catch(error => {
          console.log(error)
        })
      },
      getByTableSchema() {
        this.api.generatorProperty.getByTableSchema({
          tableSchema: this.searchForm.tableSchema
        }).then(result => {
          if (result.success) {
            this.generatorPropertyForm = result.data
          } else {
            this.$message.error(result.message)
          }
        }).catch(error => {
          console.log(error)
        })
      },
      addGeneratorRule() {
        this.generatorRuleForm.searchFormFields.forEach((e, index) => {
          this.tableColumns.forEach(a => {
            if (a.columnName === e) {
              this.generatorRuleForm.searchFormFields[index] = a
            }
          })
        });
        this.generatorRuleForm.searchFormCombineFields = []
        this.tags.forEach((e, index) => {
          let columns = []
          if (e.name.indexOf('/') > -1) {
            columns = e.name.split('/')
          } else {
            columns = [e.name]
          }
          let combineColumns = []
          columns.forEach(column => {
            this.tableColumns.forEach(a => {
              if (a.columnName === column) {
                combineColumns.push(a)
              }
            })
          })
          this.generatorRuleForm.searchFormCombineFields[index] = combineColumns
        });
        this.generatorRuleForm.addFormFields.forEach((e, index) => {
          this.tableColumns.forEach(a => {
            if (a.columnName === e) {
              this.generatorRuleForm.addFormFields[index] = a
            }
          })
        });
        this.generatorRuleForm.editFormFields.forEach((e, index) => {
          this.tableColumns.forEach(a => {
            if (a.columnName === e) {
              this.generatorRuleForm.editFormFields[index] = a
            }
          })
        });
        this.generatorRuleForm.detailFormFields.forEach((e, index) => {
          this.tableColumns.forEach(a => {
            if (a.columnName === e) {
              this.generatorRuleForm.detailFormFields[index] = a
            }
          })
        });
        this.generatorRuleForm.pageListFields.forEach((e, index) => {
          this.tableColumns.forEach(a => {
            if (a.columnName === e) {
              this.generatorRuleForm.pageListFields[index] = a
            }
          })
        });
        this.api.generatorRule.addGeneratorRule(this.generatorRuleForm).then(result => {
          if (result.success) {
            this.generatorRuleFormVisible = false
            this.$message.success(result.message)
          } else {
            this.$message.error(result.message)
          }
        }).catch(error => {
          console.log(error)
        })
      },
      getGeneratorRule() {
        this.api.generatorRule.getGeneratorRule({
          tableSchema: this.generatorRuleForm.tableSchema,
          tableName: this.generatorRuleForm.tableName
        }).then(result => {
          if (result.success) {
            if (result.data !== null) {
              this.generatorRuleForm = result.data;
              if (result.data.searchFormFields.length > 0) {
                this.generatorRuleForm.searchFormFields.forEach((e, index) => this.generatorRuleForm.searchFormFields[index] = e.columnName)
              }
              if (result.data.searchFormCombineFields !== null && result.data.searchFormCombineFields.length > 0) {
                result.data.searchFormCombineFields.forEach(columns => {
                  let tag = '';
                  columns.forEach(column => {
                    this.tableColumns.forEach(e => {
                      if (e.columnName === column.columnName) {
                        e.disabled = true
                        this.generatorRuleForm.searchFormFields.push(e.columnName)
                        return;
                      }
                    })
                    tag += column.columnName + '/'
                  })
                  tag = tag.substring(0, tag.length - 1)
                  this.tags.push({
                    name: tag
                  })
                })
              }
              this.generatorRuleForm.addFormFields.forEach((e, index) => this.generatorRuleForm.addFormFields[index] = e.columnName)
              this.generatorRuleForm.editFormFields.forEach((e, index) => this.generatorRuleForm.editFormFields[index] = e.columnName)
              this.generatorRuleForm.detailFormFields.forEach((e, index) => this.generatorRuleForm.detailFormFields[index] = e.columnName)
              this.generatorRuleForm.pageListFields.forEach((e, index) => this.generatorRuleForm.pageListFields[index] = e.columnName)
            }
          } else {
            this.$message.error(result.message)
          }
        }).catch(error => {
          console.log(error)
        })
      },
      getLastTableSchema() {
        this.api.generatorProperty.getLastTableSchema().then(result => {
          if (result.success) {
            if (result.data !== null) {
              this.searchForm.tableSchema = result.data.tableSchema
            } else {
              this.searchForm.tableSchema = null
            }
          }
        }).catch(error => {
          console.log(error)
        })
      },
      combine() {
        let tag = ''
        this.tableColumns.forEach(e => {
          this.generatorRuleForm.searchFormFields.forEach(x => {
            if (e.columnName === x && e.disabled !== true) {
              tag += e.columnName + '/'
              e.disabled = true
            }
          })
        })
        if (tag.length > 0) {
          this.tags.push({
            name: tag.substring(0, tag.length - 1)
          })
        }
      },
      clear() {
        this.tags.forEach(tag => {
          let columns = tag.name.split('/')
          this.tableColumns.forEach(e => {
            columns.forEach(x => {
              if (e.columnName === x) {
                e.disabled = false
              }
            })
          })
        })
        this.generatorRuleForm.searchFormFields = []
        this.tags = []
      },
      close(tag) {
        let columns = tag.name.split('/')
        this.tableColumns.forEach(e => {
          columns.forEach(x => {
            if (e.columnName === x) {
              e.disabled = false
            }
          })
        })
        columns.forEach(e => this.generatorRuleForm.searchFormFields.splice(this.generatorRuleForm.searchFormFields.indexOf(e), 1))
        this.tags.splice(this.tags.indexOf(tag), 1);
      },
      showRelationTable(column) {
        if (this.componentArray.indexOf(column.elementType) > -1) {
          column.relationTableVisible = true
        } else {
          column.relationTableVisible = false
        }
      }
    },
    watch: {
      'searchForm.tableSchema': function (newVal) {
        this.pageList()
      },
      'generatorRuleForm.addFormFields': function (newVal) {
        if (newVal !== null && newVal.length > 0) {
          if (this.generatorRuleForm.editFormFields !== null) {
            this.generatorRuleForm.editFormFields = newVal
          }
          if (this.generatorRuleForm.detailFormFields !== null) {
            this.generatorRuleForm.detailFormFields = newVal
          }
          if (this.generatorRuleForm.pageListFields !== null) {
            this.generatorRuleForm.pageListFields = newVal
          }
        }
      },
      'generatorRuleFormVisible': function (newVal) {
        if (!newVal) {
          this.$refs.generatorRuleForm.resetFields()
          this.tags = []
        } else {
          this.getColumns()
          this.getTables()
        }
      },
      'generatorPropertyFormVisible': function (newVal) {
        if (!newVal) {
          this.$refs.generatorPropertyForm.resetFields()
        } else {
          this.getByTableSchema()
        }
      },
      'generatorRuleForm.vueTreeNeed': function (newVal) {
        if (!newVal) {
          this.generatorRuleForm.treeCrudNeed = false
          this.generatorRuleForm.treeAssociatedTable = ''
        }
      },
      'tableColumns': function (newVal) {
        this.tableColumns.forEach(e => {
          if (this.componentArray.indexOf(e.elementType) > -1) {
            e.relationTableVisible = true
          } else {
            e.relationTableVisible = false
          }
        })
      },
    },
    mounted() {
      this.setComponentSize()
      this.getPermissionList()
      this.getTableSchemas()
      this.getLastTableSchema()
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/generator/index.vue